import React from 'react';
import InfoBox from 'components/widget/InfoBox';
import { CANT_CHANGE_ORDER_MESSAGE_DISPATCHED } from 'helpers/copyHelper';

export default () => (
  <InfoBox>
    { CANT_CHANGE_ORDER_MESSAGE_DISPATCHED() }
  </InfoBox>
);
